import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RackZoneMappingAdapter } from './rack-zone-mapping-adapter';
import { RackZoneMappingRepository } from './rack-zone-mapping-repository';
import { RackZoneMappingController } from './rack-zone-mapping.controller';
import { RackZoneMappingService } from './rack-zone-mapping.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([RackZoneMappingRepository]),
  ],
  controllers: [RackZoneMappingController],
  providers: [RackZoneMappingService,RackZoneMappingAdapter, ApplicationExceptionHandler]
})
export class RackZoneMappingModule {

}
